import React from 'react'
import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai";

const LoadingCircle = (props) => (
  // <div className="indicator" style={{ width: '100%', height: '100%', top: 0, left: 0 }}>
  //     <div className="load">
  //         <hr />
  //         <hr />
  //         <hr />
  //         <hr />
  //     </div>
  // </div>

  <div className="loading" style={props.style && props.style}>
    <div>
      <AiOutlineLoading className="mdi-spin" size="40px" color="#6e64f8" />
      {/* <div className="c1"></div>
      <div className="c2"></div>
      <div className="c3"></div>
      <div className="c4"></div> */}
    </div>
    {/* <span>loading</span> */}
  </div>

);

export default LoadingCircle;